import React from 'react';
import * as Constants from '../constants';
import HeadingBuilder from '../components/HeadingBuilder';
import ButtonWarning from '../components/ButtonWarning';
import { useTranslation } from "react-i18next";

export const AddFunctionRestricted = ({
  cantDoWhat,
  altReason,
}) => {

  const { t } = useTranslation();

  return (
    <>
      <br/>
      <ButtonWarning
        bWarningMsg = {Constants.DOT}
        forceShowBWarning  = {true}
        iconShowBWarning   = {true}
      />
      <HeadingBuilder
// headingText = {t('circle.circleNotCurrent.cantSchedTrip')}
        headingText = {cantDoWhat}
      />
      <HeadingBuilder
        headingText = {
          altReason
            ? altReason
            : t('circle.circleNotCurrent.tippyContent')
        // There is an issue with the Circle's payment status
        }
      />
    </>
  )
}

export default AddFunctionRestricted;